import { SET_FORMS_LIST, SET_FORM } from "./types";
import { setError } from "./errorActions";
import history from "../history";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getFormsList = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/forms`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_FORMS_LIST, payload: response.data.forms });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getForm = (formID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/forms/${formID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_FORM, payload: response.data.form });
        };
    }
    catch (error) { errorHandler(error, null); }
};

export const getFormFile = (formID) => async (dispatch) => {
    const target = window.open("", "_blank");

    if (!target) {
        dispatch(setError(null, "---", ["Przeglądarka zablokowała otwarcie pliku"]));
        return;
    }

    try {
        target.document.title = "Przygotowywanie pliku PDF...";

        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/forms/pdf/${formID}`, {
                responseType: "blob",
                headers: {
                    "Accept": "application/pdf",
                    "Content-Type": "application/pdf",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            if (target.closed) {
                return;
            }

            const url = URL.createObjectURL(response.data);
            target.location.replace(url);
        }
    }
    catch (error) {
        if (!target.closed) {
            target.close();
        }

        errorHandler(error, null);
    }
};

export const newForm = (formData, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/forms`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push("/forms");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editForm = (formID, formData, onFieldError) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/forms/${formID}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.push("/forms");
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const deleteForm = (formID) => async () => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.delete(`/api/forms/${formID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) history.go(0);
    }
    catch (error) { errorHandler(error, null); }
};